import { styled } from 'styled-components';

export const PortfolioHomeRoot = styled.div`
  font-family: proxima-nova, sans-serif;
  width: 100vw;
  overflow: hidden;
`;
